<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <el-tabs v-model="active" @tab-click="tabClick">
          <el-tab-pane label="交租管理" name="ownerCollectRecordAll">
            <owner-collect-record-all ref="ownerCollectRecordAll"></owner-collect-record-all>
          </el-tab-pane>
          <el-tab-pane label="收租管理" name="collectRecordAll">
            <collect-record-all ref="collectRecordAll"></collect-record-all>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>

import OwnerCollectRecordAll from "@/components/OwnerCollectRecordAll";
import CollectRecordAll from "@/components/CollectRecordAll";

export default {
  components: {
    OwnerCollectRecordAll,
    CollectRecordAll
  },
  data() {
    return {
      active: 'ownerCollectRecordAll'
    }
  },
  methods: {
    tabClick() {
      const tab = this.active
      if (tab == 'ownerCollectRecordAll') {
        this.$refs['ownerCollectRecordAll'].search(true)
      } else if (tab == 'collectRecordAll') {
        this.$refs['collectRecordAll'].search(true)
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/back/rentCollectRecord.vue